/**
 * WhatsApp buttons, which link to the app: whatsapp://send?phone=…&text=…
 * - On phones and tablets the link opens the WhatsApp app straight away. Shopify shows its
 *   "Are you sure you want to leave?" screen only before links to other websites, and an app link isn't one.
 * - On computers the same chat, with the same message, opens in WhatsApp Web in a new tab instead,
 *   so nobody without the desktop app gets the browser's "can't open this address" error.
 *   The tab is opened from this script, which Shopify's screen does not stop.
 */
const isPhoneOrTablet = () =>
  navigator.userAgentData?.mobile === true ||
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
  // iPads ask for the desktop site, so they describe themselves as a Mac
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

// The same chat and message in WhatsApp Web
const webUrl = (appHref) => {
  const app = new URL(appHref);
  const phone = app.searchParams.get('phone') || '';
  const text = app.searchParams.get('text');
  return `https://web.whatsapp.com/send?phone=${phone}${text ? `&text=${encodeURIComponent(text)}` : ''}`;
};

const openWeb = (event) => {
  if (event.type === 'auxclick' && event.button !== 1) return;
  const link = event.target.closest?.('a[href^="whatsapp:"]');
  if (!link || event.defaultPrevented || isPhoneOrTablet()) return;
  event.preventDefault();
  window.open(webUrl(link.href), '_blank', 'noopener');
};

document.addEventListener('click', openWeb);
// A middle click would otherwise try the app link in a new tab
document.addEventListener('auxclick', openWeb);
